module.exports = __webpack_public_path__ + "static/media/logo_skanmed.7c02bd0c.png";